import { computed, ref, onMounted, watch } from 'vue'
import { useStore } from 'vuex'

import BasketComponent from '../BasketComponent/BasketComponent.vue'

import { dataLayerCheckout } from '../../foundation/js/dataLayerHelpers'

export default {
    name: "OrderOverview",
    components:{
        BasketComponent
    },
    props: {
        proceedLink: {
            default: "",
            required: true
        },
        proceedType:{
            type: String,
            required: true,
            default: "cart"
        },
        fieldList:{
            required: true,
            type: Array
        }
    },
    setup(props){

        const store = useStore()
        const selectedOrderType = ref("")
        const hasDataLoaded = ref(false)
        const buttonDisabled = computed(()=>{
            return props.proceedType === 'checkout' 
                ? !store.getters['ecom/allCheckoutFormsValid'] 
                : props.proceedType === 'confirm' 
                    ? !store.state.ecom.user_accepted_terms || store.state.ecom.order_sent
                    : false
        })

        const getLabel = (labelRequested) => store.getters['labels/getLabel'](labelRequested)
        
        const selectOrderType = () => store.commit('ecom/set_customer_service_order_type', selectedOrderType.value.id)

        const proceedLabel = ((type) => {
            const labels = {
                'checkout' : 'proceedToConfirmation',
                'confirm' : 'placeOrder',
                'cart' : 'proceedToCheckout'
            }

            return labels[type]

        })(props.proceedType)

        const goToCheckout = () => {

            const proceedTo = {
                'checkout': ()=> store.dispatch('ecom/goToConfirmation'),
                'confirm': () => store.dispatch('ecom/placeOrder'),
                'cart': () => store.dispatch('ecom/goToCheckout')
            }

            const next = proceedTo.hasOwnProperty(props.proceedType) ? props.proceedType : 'cart'

            proceedTo[next]()
        }

        const cartOverviewData = computed(() => store.getters['ecom/getCartData'])

        const orderTypes = computed(() => store.state.ecom.customer_service_order_types)

        const isUserImpersonated = computed(() => {
            return orderTypes.value ? !!(orderTypes.value && orderTypes.value.length) : orderTypes.value
        })

        const isReceiptOrConfirm = (props.proceedType !== 'cart')

        watch(cartOverviewData,(newCart,oldCart)=>{
            if(props.proceedType === 'checkout' && Object.keys(newCart).length !== Object.keys(oldCart).length){
                dataLayerCheckout(newCart)
            }
            
        })

        onMounted(() => {
            store.dispatch(isReceiptOrConfirm ? 'ecom/getERPCart' :'ecom/getCart').then(res => {
                hasDataLoaded.value = res
            })
        })

        return {
            goToCheckout,
            hasDataLoaded,
            cartOverviewData,
            proceedLink: props.proceedLink,
            getLabel,
            orderTypes,
            selectedOrderType,
            selectOrderType,
            buttonDisabled,
            isUserImpersonated,
            isReceiptOrConfirm,
            proceedLabel
        }
    }
}